import { SharedState } from "../../SharedProvider";

export const selectSelectedSchedule = (state: SharedState) => state.rooms.schedules.selectedScheduleEntry;
export const selectSchedulerMouseState = (state: SharedState) => state.rooms.schedules.schedulerMouseState;
export const selectScheduleEntries = (state: SharedState) => state.rooms.schedules;
export const selectSchedulesRestSet = (state: SharedState) => state.rooms.schedules.rest;